import React, { useState, useRef, useEffect, useContext, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BiSolidCricketBall, BiFootball, BiTennisBall } from "react-icons/bi";
import "./UpcomingEvents.css";
// import "../../../src/App.css";
import { TimeContext } from "../TimeContext/TimeContext";
import { useSelector, useDispatch } from "react-redux";
import { getAllEvents } from "../../redux/slice/event/eventSlice";
import { emptyUserInfo } from "../../redux/slice/userInfo/userInfoSlice";
import Helper from "../../helper";
import ScrollGames from "../ScrollGames/ScrollGames";
import TableRow from "../TableRow/index";

const UpcomingEvents = ({ eventType }) => {
  const [currentTime, setCurrentTime] = useState(new Date("2024-08-26T04:30"));
  const scrollRefs = useRef([]); // Array of refs for each event box
  const { setMatchTime } = useContext(TimeContext);

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userInfo = Helper();

  const userInfos = useSelector((state) => state.events); // Use selector to access state
  const [allEvents, setAllEvents] = useState([]);
  const [isEventLoading, setIsEventLoading] = useState(true);
  const [events, setEvents] = useState([]);
  const [eventTypeEvents, setEventTypeEvents] = useState([]);

  const effectiveEventType =
    eventType === undefined || eventType === null ? 4 : eventType;

  // const [eventType, setEventType] = useState(4)

  // console.log('upcomingEvnets eventType : ', eventType);

  useEffect(() => {
    dispatch(
      getAllEvents({
        user_id: userInfo ? userInfo._id : "",
      })
    );
  }, []);

  // useEffect(() => {
  //   if (userInfos.events.length) {
  //     const newEvents = userInfos?.events[0]?.competitions[0]?.events || [];
  //     setIsEventLoading(false);
  //     if (newEvents.length > 0 && (allEvents.length == 0 || JSON.stringify(newEvents) !== JSON.stringify(allEvents))) {
  //       setAllEvents(newEvents);
  //     }
  //   }
  // }, [userInfos.events.length])

  useEffect(() => {
    if (
      userInfos &&
      Array.isArray(userInfos.events) &&
      userInfos.events.length > 0
    ) {
      // Flatten all competitions' events into one array
      const allNewEvents = userInfos.events
        .flatMap((ev) => ev.competitions || [])
        .flatMap((comp) => comp.events || []);
      setIsEventLoading(false);
      if (
        allNewEvents.length > 0 &&
        (allEvents.length === 0 ||
          JSON.stringify(allNewEvents) !== JSON.stringify(allEvents))
      ) {
        // console.log("Asll Events : ", allNewEvents);
        setAllEvents(allNewEvents);
      }
    }
  }, [
    userInfos && Array.isArray(userInfos.events) ? userInfos.events.length : 0,
    allEvents.length,
  ]);

  const initializeScrollRefs = (index) => {
    if (!scrollRefs.current[index]) {
      scrollRefs.current[index] = React.createRef(); // Initialize the ref for the event box
    }
  };

  const handleScroll = (scrollingRef) => {
    if (scrollingRef?.current) {
      const scrollLeftValue = scrollingRef.current.scrollLeft; // Get the scroll position of the scrolled box
      scrollRefs.current.forEach((ref) => {
        if (ref.current && ref !== scrollingRef) {
          ref.current.scrollLeft = scrollLeftValue; // Update the scroll position for all other boxes
        }
      });
    }
  };

  // const filteredEvents = useMemo(() => {
  //   if (allEvents.length > 0) {
  //     return allEvents.filter(event => event.event_type == eventType);
  //   }
  //   return [];
  // }, [allEvents, eventType]);

  const filteredEvents = useMemo(() => {
    if (allEvents.length > 0) {
      setEventTypeEvents(allEvents)
      return allEvents.filter((event) =>
        effectiveEventType == "In-Play"
          ? event.is_inplay == "True"
          : event.event_type == effectiveEventType
      );
    }
    return [];
  }, [allEvents, effectiveEventType]);

  useEffect(() => {
    setEvents(filteredEvents);
  }, [filteredEvents]);

  const handleMatchClick = (time) => {
    setMatchTime(time);
    navigate("/matchupdates"); // Navigate to MatchUpdates
  };

  useEffect(() => {
    scrollRefs.current.forEach((ref) => {
      if (ref.current) {
        // Add scroll event listener to each event box
        ref.current.addEventListener("scroll", () => handleScroll(ref));
      }
    });

    // Clean up event listeners when component unmounts
    return () => {
      scrollRefs.current.forEach((ref) => {
        if (ref.current) {
          ref.current.removeEventListener("scroll", () => handleScroll(ref));
        }
      });
    };
  }, []);

  return (
    <>
      <div className={`main ${userInfo ? 'ml-0 lg:ml-[15%]' : 'ml-0'}`}>
        {/* <ScrollGames setEventType={setEventType} /> */}
        {/* <ul className='live'>
          <li className='live-li'>LIVE</li>
          <li>My Bets(0)</li>
        </ul> */}

        {/* Cricket Section */}
        {/* {events?.length > 0 && (
          <div className="cricket">
            <div className="header-box">
              {
                eventType == "4" ?
                  <>
                    <BiSolidCricketBall size={25} color="orange" style={{ marginRight: 5, marginLeft: 5, marginTop: 3 }} />
                    <span>Cricket</span>
                  </>
                  : eventType == "2" ?
                    <>
                      <BiTennisBall size={25} color="orange" style={{ marginRight: 5, marginLeft: 5, marginTop: 3 }} />
                      <span>Tennis</span>
                    </>
                    : eventType == "1" ?
                      <>
                        <BiFootball size={25} color="orange" style={{ marginRight: 5, marginLeft: 5, marginTop: 3 }} />
                        <span>Football</span>
                      </>
                      :
                      <></>
              }

            </div>
            <div className="bet-numbers">
              <div className="box"><span>1</span></div>
              <div className="box"><span>X</span></div>
              <div className="box"><span>2</span></div>
            </div>
          </div>
        )} */}

        {/* {events?.length > 0 && (
          <div className="cricket-header">
            <div className="header-left">
              <div className="header-left-inner">
                <img
                  src={
                    eventType == "4"
                      ? "https://bx-s3-dev-001.s3.ap-southeast-1.amazonaws.com/icons/cr1.png"
                      : eventType == "2"
                      ? "https://bx-s3-dev-001.s3.ap-southeast-1.amazonaws.com/Logo/tennis.png"
                      : eventType == "1"
                      ? "https://bx-s3-dev-001.s3.ap-southeast-1.amazonaws.com/Logo/soccer.png"
                      : ""
                  }
                  alt=""
                />
                <span>
                  {eventType == "4"
                    ? "Cricket"
                    : eventType == "2"
                    ? "Tennis"
                    : eventType == "1"
                    ? "Football"
                    : ""}
                </span>
                <span className="bg-cross" style={{ background: "rgb(193, 9, 47)" }}></span>
              </div>
            </div>
            <div className="header-right">
              <div><span className="text">1</span></div>
              <div><span className="text">x</span></div>
              <div><span className="text">2</span></div>
            </div>
          </div>
        )} */}
        {/* {events?.length > 0 && (
          <div
            className="cricket-header flex justify-between items-center"
            style={{
              background: "#18adc5",
              minHeight: "32px",
              borderTopLeftRadius: "0px",
              borderTopRightRadius: "0px",
            }}
          >
            <div className="header-left relative" style={{ width: "" }}>
              <div
                className="header-left-inner"
                style={{
                  width: "8rem",
                  minWidth: "0px",
                  height: "28px",
                  borderTopLeftRadius: "0px",
                  paddingLeft: "0px",
                  paddingRight: "0px",
                }}
              >
                <div className="flex justify-start items-center w-32">
                  <span>
                    {effectiveEventType == 4
                      ? "Cricket"
                      : effectiveEventType == 2
                        ? "Tennis"
                        : effectiveEventType == 1
                          ? "Football"
                          : effectiveEventType == "In-Play"
                            ? "In-Play"
                            : ""}
                  </span>
                </div>
              </div>
            </div>
          </div>
        )} */}
        {((effectiveEventType == "In-Play" && (location.state?.subSport == "live" || location.state?.subSport == 4)) || effectiveEventType == '4') && (
          <>
            {eventTypeEvents?.length > 0 && eventTypeEvents?.filter((item => item.event_type == "4")).length > 0 && (
              <div
                className="cricket-header flex justify-between items-center"
                style={{
                  background: "#18adc5",
                  minHeight: "32px",
                  borderTopLeftRadius: "0px",
                  borderTopRightRadius: "0px",
                }}
              >
                <div className="header-left relative" style={{ width: "" }}>
                  <div
                    className="header-left-inner"
                    style={{
                      width: "8rem",
                      minWidth: "0px",
                      height: "28px",
                      borderTopLeftRadius: "0px",
                      paddingLeft: "0px",
                      paddingRight: "0px",
                    }}
                  >
                    <div className="flex justify-start items-center w-32">
                      <span>
                        Cricket
                      </span>
                    </div>
                  </div>
                </div>

              </div>
            )}
            {eventTypeEvents?.filter((item => item.event_type == "4"))?.map((event, index) => (
              <TableRow key={event.event_id || index} i={index} row={event} />
            ))}
          </>)
        }
        {((effectiveEventType == "In-Play" && (location.state?.subSport == "live" || location.state?.subSport == 1)) || effectiveEventType == '1') && (
          <>
            {eventTypeEvents?.length > 0 && eventTypeEvents?.filter((item => item.event_type == "1" || (effectiveEventType == "In-Play" && item.is_inplay == "True"))).length > 0 && (
              <div
                className="cricket-header flex justify-between items-center"
                style={{
                  background: "#18adc5",
                  minHeight: "32px",
                  borderTopLeftRadius: "0px",
                  borderTopRightRadius: "0px",
                }}
              >
                <div className="header-left relative" style={{ width: "" }}>
                  <div
                    className="header-left-inner"
                    style={{
                      width: "8rem",
                      minWidth: "0px",
                      height: "28px",
                      borderTopLeftRadius: "0px",
                      paddingLeft: "0px",
                      paddingRight: "0px",
                    }}
                  >
                    <div className="flex justify-start items-center w-32">
                      <span>
                        Soccer
                      </span>
                    </div>
                  </div>
                </div>

              </div>
            )}
            {eventTypeEvents?.filter((item => item.event_type == "1" || (effectiveEventType == "In-Play" && item.is_inplay == "True")))?.map((event, index) => (
              <TableRow key={event.event_id || index} i={index} row={event} />
            ))}
          </>)
        }
        {((effectiveEventType == "In-Play" && (location.state?.subSport == "live" || location.state?.subSport == 2)) || effectiveEventType == '2') && (
          <>
            {eventTypeEvents?.length > 0 && eventTypeEvents?.filter((item => item.event_type == "2" || (effectiveEventType == "In-Play" && item.is_inplay == "True"))).length > 0 && (
              <div
                className="cricket-header flex justify-between items-center"
                style={{
                  background: "#18adc5",
                  minHeight: "32px",
                  borderTopLeftRadius: "0px",
                  borderTopRightRadius: "0px",
                }}
              >
                <div className="header-left relative" style={{ width: "" }}>
                  <div
                    className="header-left-inner"
                    style={{
                      width: "8rem",
                      minWidth: "0px",
                      height: "28px",
                      borderTopLeftRadius: "0px",
                      paddingLeft: "0px",
                      paddingRight: "0px",
                    }}
                  >
                    <div className="flex justify-start items-center w-32">
                      <span>
                        Tennis
                      </span>
                    </div>
                  </div>
                </div>

              </div>
            )}
            {eventTypeEvents?.filter((item => item.event_type == "2" || (effectiveEventType == "In-Play" && item.is_inplay == "True")))?.map((event, index) => (
              <TableRow key={event.event_id || index} i={index} row={event} />
            ))}
          </>)
        }


      </div >
    </>
  );
};

export default UpcomingEvents;
